/**
 * Implements a button collection view
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import GenericButton from "./";
import GenericButtonCollection from "../../../collections/buttons";

const channel = Radio.channel("report");

const DEFAULTS = {
  childView: GenericButton,
};

class ButtonCollection extends Marionette.CollectionView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    // listen for filter updated event, if defined
    if (this.options.updatedFilterEventName) {
      this.listenTo(channel, this.options.updatedFilterEventName, () => {
        // disable buttons when the event is fired
        this.$("button").addClass("disabled");
      });
    }

    // localize meta object
    this.meta = this.options.meta;

    // localize model, when it exists
    this.model = null;
    if (_.has(this.meta, "model")) {
      this.model = this.meta.model;
      // force render whenever the model changes
      this.listenTo(this.model, "change", this.render);
    }
  }

  onBeforeRender() {
    this.collection = new GenericButtonCollection();

    const metadata = this.meta;

    /**
     * Determine if all buttons are to be displayed.
     *
     * displayFn is typically used by form buttons that instantiate
     * this module directly.
     */
    _.each(this.options.buttons, (button) => {
      // assume we'll display this button
      let display = true;
      // is a display function defined?
      if (_.isFunction(button.displayFn)) {
        // call displayFn and pass the scope and metadata object to
        // determine if button is to be displayed
        display = button.displayFn.apply(this, [metadata]);
      }

      // add button to collection if it should be displayed
      if (display) {
        this.collection.add(button);
      }
    });

    // eliminate items that should not appear based on role
    this.collection.remove(this.collection.where({ validRole: false }));
    // console.dir(this.collection.toJSON());

    /**
     * Update collection with final/calculated datasources.
     *
     * Typically needed for report action buttons that need to
     * trigger custom events.
     */
    _.each(this.options.buttonsData, (button) => {
      const model = this.collection.findWhere({
        action: button.get("action"),
      });
      if (model) {
        // apply all button properties to this model
        model.set(button.toJSON());
      }
    });
  }

  // generates the options needed by the view
  childViewOptions(child) {
    // accepts each of the collection models.
    // use this method to modify the model if necessary
    return child.toJSON();
  }
}

export { ButtonCollection as default };
